import { useState } from 'react'
import type { GestureResponderEvent } from 'react-native'

import { ListboxItem, type TListboxItemProps } from '../listbox'

export const useActionSheet = () => {
  const [isActionSheetVisible, setIsActionSheetVisible] = useState(false)
  const renderActionItem = ({ onPress, ...otherProps }: TListboxItemProps, index: number) => (
    <ListboxItem
      key={index}
      onPress={(e: React.MouseEvent<HTMLAnchorElement> | GestureResponderEvent) => {
        setIsActionSheetVisible(false)
        onPress?.(e)
      }}
      {...otherProps}
    />
  )

  return { isActionSheetVisible, setIsActionSheetVisible, renderActionItem }
}
